import forgotPasswordSagas from './forgotPassword'

// CODE_COMMENTS_11
export default [
  ...forgotPasswordSagas,
]
